import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, ParamMap, Params, Router} from '@angular/router';
import {SigmanRestService} from "../../rest-services/sigman.rest.service";
import {AdsnUiType} from '@adsn/angular-ui';
import {catchError, debounceTime, Observable} from 'rxjs';
import {Client} from '../../modules/modele/client';
import {error} from 'protractor';

@Component({
    selector: 'app-client-redirect',
    templateUrl: './client-redirect.component.html',
    styleUrls: ['./client-redirect.component.scss']
})
export class ClientRedirectComponent implements OnInit {

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private sigmanRestService: SigmanRestService) {
    }

    checkInfosRequired = false;
    snapshot: ActivatedRouteSnapshot;
    prenomNom: string;

    protected readonly AdsnUiType = AdsnUiType;

    ngOnInit(): void {
        this.snapshot = this.activatedRoute.snapshot;

        // Récupération des queryParams envoyés par le partenaire
        if ( this.snapshot.queryParamMap.get('actionId') === 'creationIdentiteNumerique') {
            this.sigmanRestService.getInformationsClient(this.snapshot.paramMap.get('idClient'))
                .subscribe({
                    next: (response) => {
                        this.prenomNom = response.body.prenom + ' ' + response.body.nom;},
                    complete: () => {
                        this.checkInfosRequired = true;
                    },
                    error: (error) => {
                        console.log('error:', error);
                    }
                });
        } else {
            // Récupération de l'identifiant de la session de signature
            this.goToExternalUrl();
        }
    }

    annuler() {
        this.router.navigate(['fin_de_session'],
            { queryParams: { sigResult: 'INVALID_INFOS_CLIENT' },  queryParamsHandling: 'merge' });
    }

    goToExternalUrl() {
        this.checkInfosRequired = false;
        this.sigmanRestService.getUrlSignature(this.snapshot.paramMap.get('idClient'), this.snapshot.queryParamMap).subscribe(
            (response) => {
                console.log('ClientRedirectComponent::getUrlSignature() - response:', response);
                if (response.status === 200) {
                    this.router.navigate(['externalRedirect', {externalUrl: response.body.url}]);
                } else if (response.status === 208) {
                    this.router.navigate(['fin_de_session'],
                        { queryParams: { sigResult: 'ALREADY_REPORTED' },  queryParamsHandling: 'merge' });
                }
            }, (error) => {
                console.log('error:', error);
            }, () => this.snapshot = null
            );
    }
}
